import React, { useState } from 'react';
import DeleteIcon from '@mui/icons-material/Delete'; // or wherever you're importing it from
const PageList = ({ page, onDelete }) => {
    if (page?.sts !== '0') return null;

    return (
        <span style={{ display: 'flex' }}>
            {page.pages}
            <DeleteIcon
                style={{ cursor: 'pointer', marginLeft: 8 }}
                onClick={onDelete}
            />
        </span>
    );
};

export default React.memo(PageList);